import { AuthFormNames } from '~/models/FormNames';
import { getHashValue, getHashValueSlices } from '~/utils/parseUrlHelper';
import { HashValues } from '~/constants/hashValues';

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return;
  }

  if (to.hash) {
    const formNames: string[] = Object.values(AuthFormNames);
    const hashValueSlices = getHashValueSlices(getHashValue(to.hash));
    const userStore = useUserStore();
    const { isLoggedIn } = storeToRefs(userStore);

    if (formNames.includes(hashValueSlices[0]) && (!isLoggedIn.value || hashValueSlices[0] === HashValues.VERIFY_EMAIL)) {
      userStore.openAuthForm(...hashValueSlices);
    } else {
      console.log('unknown hash! ', hashValueSlices[0]);
    }
  }
});
